import { toast as customToast } from "./sonner";

// Helper function to dismiss only toaster notifications
const dismissAllToasts = () => {
  // Get all toast elements with our specific class
  const toastElements = document.querySelectorAll('.wl-toast-item');
  toastElements.forEach((element) => {
    // Find the toast ID and dismiss it
    const toastId = element.getAttribute('data-sonner-toast-id');
    if (toastId) {
      customToast.dismiss(toastId);
    }
  });
};

/**
 * Custom hook for managing toast notifications.
 * 
 * @returns Object with toast methods
 */
export function useToast() {
  return {
    /**
     * Show a default toast notification.
     */
    toast: (title: string, options?: any) => {
      console.log("useToast.toast called with:", title, options);
      return customToast.show(title, options);
    },
    /**
     * Show a success toast notification.
     */
    success: (title: string, options?: any) => {
      console.log("useToast.success called with:", title, options);
      return customToast.success(title, options);
    },
    /**
     * Show an error toast notification.
     */
    error: (title: string, options?: any) => {
      console.log("useToast.error called with:", title, options);
      return customToast.error(title, options);
    },
    /**
     * Show a warning toast notification.
     */
    warning: (title: string, options?: any) => {
      console.log("useToast.warning called with:", title, options);
      return customToast.warning(title, options);
    },
    /**
     * Show an info toast notification.
     */
    info: (title: string, options?: any) => {
      console.log("useToast.info called with:", title, options);
      return customToast.info(title, options);
    },
    /**
     * Show a promise-based toast notification.
     */
    promise: (promise: Promise<any>, options: any) => {
      console.log("useToast.promise called with:", promise, options);
      return customToast.promise(promise, options);
    },
    /**
     * Dismiss a specific toast by ID.
     */
    dismiss: (toastId?: string | number) => {
      console.log("useToast.dismiss called with:", toastId);
      customToast.dismiss(toastId);
    },
    /**
     * Dismiss all currently visible toasts.
     */
    dismissAll: () => {
      console.log("useToast.dismissAll called");
      dismissAllToasts();
    },
  };
}
